import type en from '../en/nav'
import type { Translation } from '../types'

/** The menu and the frame around every page */
const nav: Translation<typeof en> = {
  "nav.overview": "Overzicht",
  "nav.admins": "Beheerders",
  "nav.models": "Modellen",
  "nav.companies": "Bedrijven",
  "nav.settings": "Instellingen",
  "nav.vpn": "VPN",
  "nav.edge": "Edge-proxy",
  "nav.licensePlans": "Licentieplannen",
  "nav.licenseOverview": "Licentieoverzicht",
  "nav.myProfile": "Mijn profiel",
  "nav.dashboard": "Dashboard",
  "nav.monitoring": "Monitoring",
  "nav.alerts": "Meldingen",
  "nav.sites": "Locaties",
  "nav.templates": "Sjablonen",
  "nav.users": "Gebruikers",
  "nav.roles": "Rollen",
  "nav.branding": "Huisstijl",
  "nav.messages": "Berichten",
  "nav.apiKeys": "API-sleutels",
  "nav.webhooks": "Webhooks",
  "nav.notifications": "Notificaties",
  "nav.roleGlobalAdmin": "Globale beheerder",
  "nav.roleAdmin": "Beheerder",
  "nav.roleUser": "Gebruiker",
  "nav.switchCompany": "Ander bedrijf kiezen",
  "nav.logout": "Uitloggen",
  "nav.expand": "Uitklappen",
  "nav.collapse": "Inklappen",
  "nav.expandMenu": "Het menu uitklappen",
  "nav.collapseMenu": "Het menu inklappen",
  "nav.openMenu": "Menu openen",
  "nav.closeMenu": "Menu sluiten",
  "nav.licenseExpired": "Uw licentie is verlopen. Het dashboard is alleen-lezen totdat deze is verlengd.",
  "nav.passwordLeaked": "Uw wachtwoord komt voor in een bekend datalek; anderen kunnen het dus proberen.",
  "nav.passwordLeakedChange": "Wijzig het nu onder",
  "nav.rental": "Verhuur",
  "nav.inbox": "Inbox",
  "nav.inboxUnread": "Inbox, {count} ongelezen",
  "nav.inboxReadAll": "Alles als gelezen markeren",
  "nav.inboxEmpty": "Hier staat nog niets",
  "nav.pushRelay": "Push-doorgifte",
}

export default nav
